import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSchool: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="school, building"><path fillRule="evenodd" clipRule="evenodd" d="M6 7.75C6 5.67893 7.67893 4 9.75 4H14.25C16.3211 4 18 5.67893 18 7.75V18.5H19V8.07501C20.7117 8.42247 22 9.93578 22 11.75V18.5H22.25C22.6642 18.5 23 18.8358 23 19.25C23 19.6642 22.6642 20 22.25 20H1.75C1.33579 20 1 19.6642 1 19.25C1 18.8358 1.33579 18.5 1.75 18.5H2V11.75C2 9.93578 3.28832 8.42247 5 8.07501V18.5H6V7.75ZM14 18.5V17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17V18.5H14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSchool;
